import { Dimensions } from "react-native";
import { BREAKPOINTS_EXTENDED } from '@/constants/Core';
import { isJSON } from '@/helper/Json';

export const resolvedBreakpoint = (obj, windowWidth = null) => {
    
    const {
        xs: _xs = null,
        sm: _sm = null, 
        md: _md = null,
        lg: _lg = null,
        xl: _xl = null,
        xxl: _xxl = null
    } = obj || {};
    
    if (!isJSON(obj)) {
        return obj;
    }

    if (!_xs && !_sm && !_md && !_lg && !_xl && !_xxl) 
        return null;
    
    if (windowWidth == null)
        windowWidth = Dimensions.get('window').width;

    const xs = obj.xs ?? null;
    const sm = obj.sm ?? xs;
    const md = obj.md ?? sm;
    const lg = obj.lg ?? md;
    const xl = obj.xl ?? lg;
    const xxl = obj.xxl ?? xl;

    if (windowWidth >= BREAKPOINTS_EXTENDED.xxl) 
        return xxl;

    if (windowWidth >= BREAKPOINTS_EXTENDED.xl)
        return xl;

    if (windowWidth >= BREAKPOINTS_EXTENDED.lg)
        return lg;

    if (windowWidth >= BREAKPOINTS_EXTENDED.md)
        return md;

    if (windowWidth >= BREAKPOINTS_EXTENDED.sm)
        return sm;

    return xs;
}